export default __webpack_public_path__ + "static/media/eatingtimes@3x.cbcb922a.jpg";